/**
 * bm-tabs-stable-height — on an <md-tabs md-dynamic-height>, keeps the tabs as tall as
 * their TALLEST tab, so switching tabs never resizes the dialog around them, without
 * reserving a hard-coded height (which leaves short tabs mostly blank).
 *
 *   <md-tabs md-dynamic-height bm-tabs-stable-height> ... </md-tabs>
 *
 * md-dynamic-height is required: with it Angular Material renders every tab's content
 * (not just the active one), so all of them can be measured. Inactive md-tab-content
 * boxes are absolutely positioned at the active tab's height, so their scrollHeight is
 * max(own content, active content) — the max over all tabs is the tallest tab. The
 * min-height follows content changes (data loading, instance switch) both ways; it only
 * never depends on which tab is active.
 */
angular.module('bizmetryApp').directive('bmTabsStableHeight', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            var tabs = element[0];
            var observer = null;
            var observed = [];
            var frame = null;

            function measure() {
                frame = null;
                var header = tabs.querySelector('md-tabs-wrapper');
                var tallest = 0;
                Array.prototype.forEach.call(tabs.querySelectorAll('md-tab-content'), function (content) {
                    tallest = Math.max(tallest, content.scrollHeight);
                });
                if (!tallest) return;
                tabs.style.minHeight = (tallest + (header ? header.offsetHeight : 0)) + 'px';
            }

            function scheduleMeasure() {
                if (frame === null) frame = window.requestAnimationFrame(measure);
            }

            // Watch each tab's rendered content (md-tab-content > div), so async content in
            // an inactive tab is measured too. Re-run when the set of tabs changes.
            function observeContents() {
                var bodies = tabs.querySelectorAll('md-tab-content > div');
                if (!observer || bodies.length === observed.length) return;
                observer.disconnect();
                observed = Array.prototype.slice.call(bodies);
                observed.forEach(function (body) { observer.observe(body); });
            }

            if (window.ResizeObserver) {
                observer = new ResizeObserver(scheduleMeasure);
                observer.observe(tabs.querySelector('md-tabs-wrapper') || tabs);
            }

            var stopWatch = scope.$watch(function () {
                return tabs.querySelectorAll('md-tab-content > div').length;
            }, function () {
                $timeout(function () { observeContents(); scheduleMeasure(); }, 0, false);
            });

            scope.$on('$destroy', function () {
                stopWatch();
                if (observer) observer.disconnect();
                if (frame !== null) window.cancelAnimationFrame(frame);
            });
        }
    };
});
